// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-card {
  background-color: white;
  /* background-color: #cccccc69; */
  padding: 1.25rem 1.25rem 1.25rem 1.25rem;
  margin: 0 0.625rem;
  border-radius: 0.438rem;
  min-height: 43.75rem;
}
.campaign-card .artwork {
  width: 100%;
  display: flex;
  justify-content: center;
}
.campaign-card img {
  object-fit: contain;
  border-radius: 0.625rem;
  /* box-shadow: var(--boxShadow); */
  filter: drop-shadow(0.313rem 0.313rem 0.313rem hsl(0deg 0% 0%/0.5));
}
.campaign-card div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.campaign-card p {
  font-size: 1rem;
  font-weight: 400;
}
.campaign-card .heading {
  text-align: center;
  margin: 1.25rem 0;
  height: 3.125rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/campaignCard.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".campaign-card {\n  background-color: white;\n  /* background-color: #cccccc69; */\n  padding: 1.25rem 1.25rem 1.25rem 1.25rem;\n  margin: 0 0.625rem;\n  border-radius: 0.438rem;\n  min-height: 43.75rem;\n}\n.campaign-card .artwork {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n.campaign-card img {\n  object-fit: contain;\n  border-radius: 0.625rem;\n  /* box-shadow: var(--boxShadow); */\n  filter: drop-shadow(0.313rem 0.313rem 0.313rem hsl(0deg 0% 0%/0.5));\n}\n.campaign-card div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.campaign-card p {\n  font-size: 1rem;\n  font-weight: 400;\n}\n.campaign-card .heading {\n  text-align: center;\n  margin: 1.25rem 0;\n  height: 3.125rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
